import React, { ElementType } from 'react';
import clsx from 'clsx';
import type {} from '@mui/lab/themeAugmentation';


export type Forbid<TType, TForbid> = TType & {
    [K in keyof TForbid]?: never;
};

export type ComponentWrapper<PComponent, PWrapper> = PWrapper & {
    component: ElementType<Forbid<PComponent, PWrapper>>;
    componentRef?: React.Ref<any>;
};

export type ComponentWrapperProps<PComponent, PWrapper> = PComponent &
ComponentWrapper<PComponent, PWrapper>;

export type ClassName = { className?: string };
export { clsx as cn };

type Join<K, P> = K extends string | number
    ? P extends string | number
        ? `${K}${'' extends P ? '' : '.'}${P}`
        : never
    : never;

type Prev = [
    never,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    ...0[],
];

export type Paths<T, D extends number = 10> = [D] extends [never]
    ? never
    : T extends object
        ? {
            [K in keyof T]-?: K extends string | number
                ? `${K}` | Join<K, Paths<T[K], Prev[D]>>
                : never;
        }[keyof T]
        : '';
